import { useIsPlace } from "../reducers/layoutReducer/selectors";

const HeroHeader = () => {
  const isPlace = useIsPlace();
  return (
    <div className="tw-relative">
      <div className="tw-absolute tw-flex tw-items-stretch tw-w-full tw-overflow-hidden [mask-image:linear-gradient(black_70%,transparent)] tw-h-[400px]">
        <video
          src={isPlace ? "/images/place-gradient.mp4" : "/images/brivity-gradient.mp4"}
          autoPlay
          loop
          muted
          className="tw-object-cover tw-object-center tw-w-full"
        />
      </div>
      <div className="tw-relative tw-flex tw-flex-col tw-gap-[16px] tw-max-w-[700px] tw-mx-auto tw-text-center tw-pt-[80px]">
        <div
          className={`${isPlace ? "tw-text-[20px]" : ""} tw-uppercase tw-leading-[20px] tw-text-gray-50 tw-tracking-[2px] tw-font-[500]`}
        >
          {isPlace ? "Place Partners Get" : "Power Up Your Business With"}
        </div>
        <div className="tw-text-[40px] tw-leading-[40px]">
          {isPlace ? "Unlimited Access to Add-Ons" : "Brivity Add-Ons"}
        </div>
        <div>
          {isPlace ? (
            <div className="tw-flex tw-flex-col tw-gap-[8px]">
              <div>
                <b>Thanks for being a Partner!</b> As part of PLACE, you get unlimited access to the most
                powerful, cutting edge technology available to agents in order to fuel your real estate
                success <em>at no additional cost*.</em>
              </div>
              <div className="tw-text-[12px]">*Applies to SaaS add on products.</div>
            </div>
          ) : (
            <div className="tw-text-gray-50">
              Stay ahead of the market and give your team the competitive edge.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroHeader;
